// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JZzD","toggleWrap":"styles_toggleWrap__3g3j-","content":"styles_content__1vKVb","selectAreaCode":"styles_selectAreaCode__NKaJb"};